export default __webpack_public_path__ + "static/media/img_frame.2a9dfcd0.svg";